export class CommonMethods {

    static exportExcel(arrObj, fileName) {
        import("xlsx").then(xlsx => {
            const worksheet = xlsx.utils.json_to_sheet(arrObj);
            const workbook = { Sheets: { 'Data': worksheet }, SheetNames: ['Data'] };
            const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
            this.saveAsExcelFile(excelBuffer, fileName);
        });
    }
    static saveAsExcelFile(buffer: any, fileName: string): void {
        import("file-saver").then(FileSaver => {
            let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
            let EXCEL_EXTENSION = '.xlsx';
            const data: Blob = new Blob([buffer], {
                type: EXCEL_TYPE
            });
            FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
        });
    }

    static changeDateFormatDDMMYYYY(givenDate){
        if(new Date(givenDate)){
            let dd = new Date(givenDate);
            let day = dd.getDate()+"";
            let month = dd.getMonth()+1+"";
            let year = dd.getFullYear();
            return (day.length ==2 ? day : "0"+day) +"/"+(month.length ==2 ? month : "0"+month)+"/"+year;
        }
        return '';
    }
    static changeDateFormatDD_MM_YYYY(givenDate){
        if(new Date(givenDate)){
            let dd = new Date(givenDate);
            let day = dd.getDate()+"";
            let month = dd.getMonth()+1+"";
            let year = dd.getFullYear();
            return (day.length ==2 ? day : "0"+day) +"-"+(month.length ==2 ? month : "0"+month)+"-"+year;
        }
        return '';
    }
    // static changeDateFormatYYYYMMDD(givenDate){
    //     if(new Date(givenDate)){
    //         let dd = new Date(givenDate);
    //         let day = dd.getDate()+"";
    //         let month = dd.getMonth()+1+"";
    //         let year = dd.getFullYear();
    //         return year +"/"+(month.length ==2 ? month : "0"+month)+"/" +(day.length ==2 ? day : "0"+day);
    //     }
    //     return '';
    // }

    static getMultipleBusinessUnitsArray(buIDs:string, buNames:string) {
        let ids = buIDs.split(",");
        let names = buNames.split(",");
        let buArr =[];
        for(let i=0;i<ids.length ;i++){
            buArr.push({"autoId":ids[i], "name":names[i]})
        }
        return buArr;
    }
}
